import { z } from 'zod'

export const currencies = ['GBP', 'USD', 'EUR', 'JPY', 'ILS']

export const schema = z.object({
  isin: z.string().min(1),
  sedol: z.string().optional(),
  bbg_ticker: z.string().min(1),
  price_type: z.string().min(1),
  currency: z.string().min(1),
  description: z.string().min(1),
})

export type SchemaType = z.infer<typeof schema>
